import React from 'react'
import PropTypes from 'prop-types'

import { createMarkup } from '../../lib/helpers'
import useDropdown from '../DropDown'
import { Menu } from '../DropDown.styles'

import LayerDescription from '../map/LayerDescription'
import { LayersNavWrapepr, NavCustomLink } from './Navigation.styles'

const LayersNav = ({
  activeLayer,
  dispatch,
  content,
  lang,
  layerDescription
}) => {
  const {
    activeItem,
    menuItems,
    setSelected,
    opened,
    ...layersDropDown
  } = useDropdown({
    active: activeLayer,
    items: content,
    callback: opened => {
      dispatch({
        type: 'setActiveNav',
        payload: opened ? 'layer-nav' : null
      })
    }
  })

  function onClick({ id }) {
    setSelected(id)
    dispatch({
      type: 'setActiveNav',
      payload: null
    })
  }
  return (
    <LayersNavWrapepr>
      {layersDropDown.renderToggleButton({
        label: activeItem ? activeItem.title[lang] : 'select'
      })}

      <LayerDescription
        description={layerDescription}
        opened={opened}
        lang={lang}
      />

      <Menu opened={opened}>
        {menuItems.map(item => (
          <NavCustomLink
            to={item.link}
            onClick={() => onClick(item)}
            key={item.id}
          >
            <span dangerouslySetInnerHTML={createMarkup(item.title[lang])} />
          </NavCustomLink>
        ))}
      </Menu>
    </LayersNavWrapepr>
  )
}

LayersNav.propTypes = {
  lang: PropTypes.string,
  layerDescription: PropTypes.object,
  activeLayer: PropTypes.string,
  content: PropTypes.array,
  dispatch: PropTypes.func
}

export default LayersNav
